import Flex from "@irati/ui/src/Flex"
import theme from "@irati/ui/src/global/theme"
import {Body} from "@irati/ui/src/Typography"
import {Hr} from "@irati/ui/src/Layout"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {FormattedCurrency, FormattedMessage} from "@irati/utils/lang"
import {Deal, PaymentCurrencyType} from "@irati/types"
import React, {FC} from "react"
import {UseBasket} from "@irati/checkout/utils/basket/useBasket"
import {BalanceLeft} from "./styled"
import SummaryProductInfo from "./SummaryProductInfo"

interface Props {
  basket: UseBasket
  totalLeft: number | null
  deal: Required<Deal>
}

const Summary: FC<Props> = ({deal, basket, totalLeft}) => {
  return (
    <Flex direction="column" width="100%">
      <SummaryProductInfo cardImage={deal.cardImage} header={deal.header} />
      <Hr />
      <Flex gap={theme.spacing.one}>
        <Icon icon={IconTypes.package} size={25} />
        <Body>
          <FormattedMessage id="flexiRewards.merchandise.checkout.summary.tracked" />
        </Body>
      </Flex>
      <Hr />
      <Flex justifyContent="space-between" width="100%" alignItems="center">
        <Body weight="bold">
          <FormattedMessage id="flexiRewards.merchandise.checkout.summary.total" />
        </Body>
        <Body weight="bold">
          <FormattedCurrency isCents currency={PaymentCurrencyType.Rp} value={basket.breakdown.total?.amount} />
        </Body>
      </Flex>
      <BalanceLeft>
        <Body small marginRight={1}>
          <FormattedMessage id="flexiRewards.merchandise.checkout.summary.balance.first" />
        </Body>
        <FormattedCurrency isCents currency={PaymentCurrencyType.Rp} value={totalLeft} />
        <Body small marginLeft={1}>
          <FormattedMessage id="flexiRewards.merchandise.checkout.summary.balance.second" />
        </Body>
      </BalanceLeft>
    </Flex>
  )
}

export default Summary
